<template>
  <div id="app">
    <header-component />
    <side-bar />
    <div class="fixed-nav-adjustment content-area">
      <router-view />
    </div>
    <footer-component />
  </div>
</template>

<script>
import FooterComponent from './components/FooterComponent.vue';
import HeaderComponent from './components/HeaderComponent.vue';
import SideBar from './components/SideBar.vue';

export default {
  name: "App",
  components: { 
    HeaderComponent, 
    FooterComponent, 
    SideBar },
  computed: {
    isLoggedIn() {
      return !!localStorage.getItem('token');
    },
  },
  methods: {
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('username');
      this.$router.push('/').then(() => {
        window.location.reload();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed-nav-adjustment {
  margin-top: 55px;
}

.content-area {
  margin-left: 200px;
  padding: 1rem;

  @media (max-width: 767.98px) {
    margin-left: 0;
  }
}
</style>
